import { connect } from 'react-redux'
import { Audio } from './Audio.jsx'
import { getCurrentMediaProps } from 'redux/mediaList/selectors'
import {
    currentMediaSourceLoaded,
    currentMediaSourceLoading,
    unableToLoadCurrentMedia,
} from 'redux/currentMedia/actions'

const mapStateToProps = state => getCurrentMediaProps(state)

const mapDispatchToProps = (dispatch, ownProps) => ({
    sourceLoading: () => dispatch(currentMediaSourceLoading(ownProps.id)),
    sourceLoaded: () => dispatch(currentMediaSourceLoaded(ownProps.id)),
    unableToLoadMedia: () => dispatch(unableToLoadCurrentMedia()),
})

export const AudioContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Audio)
